import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import Reveal from './Reveal';
import HeaderReveal from './HeaderReveal';
import CropAvatar from './CropAvatar/CropAvatar';
import AvatarMosaic from './AvatarMosaic/AvatarMosaic';
import * as revealActions from '../../../actions/revealActions';
import * as messageAlert from '../../../actions/messageAlertAction';
import { getLogger } from '../../../services/logger';
import PanelsBottomRowButton from '../PanelsBottomRowButton';
const debug = getLogger('components:user:profile:reveal');

export const AVATAR_SELECTOR_REVEAL = 'avatarSelectorReveal';

export class ImageSelectorReveal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.closeModal = this.closeModal.bind(this);
    this.handleCropClick = this.handleCropClick.bind(this);
    this.setImageToCrop = this.setImageToCrop.bind(this);
    this.state = {
      showImagesMosaic: true
    };
  }

  static propTypes = {
    uploadAsset: PropTypes.func,
    selectAvatarCallback: PropTypes.func,
    images: PropTypes.object,
    colors: PropTypes.object,
    selectedImage: PropTypes.string,
    revealActions: PropTypes.object,
    itemClass: PropTypes.string,
    classroomPicture: PropTypes.number,
    classroomAsset: PropTypes.string,
    ratio: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    originX: PropTypes.number,
    originY: PropTypes.number,
    selectingClassroomImage: PropTypes.bool
  };

  setCropperRef = ref => {
    this.cropper = ref;
  };

  closeModal = event => {
    this.props.revealActions.setOpenReveal();
    this.setState({
      file: undefined,
      showImagesMosaic: true,
      existsImage: false
    });
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
  };

  setImageToCrop = file => {
    let _this = this;

    var reader = new FileReader();
    reader.onloadend = function() {
      _this.setState({
        file: reader.result,
        showImagesMosaic: false
      });
    };
    reader.readAsDataURL(file);
  };

  handleCropClick = () => {
    const { uploadAsset } = this.props;

    let imageCrop = this.cropper.crop();
    this.setState({ existsImage: true });
    uploadAsset(imageCrop)
      .then(() => {
        this.closeModal();
      })
      .catch(err => {
        debug.error('[ImageSelectorReveal] uploadAsset %s', err);
        messageAlert.error(I18n.t('upload.error'));
        this.closeModal();
      });
  };

  getUserImages = () => {
    const { images, selectAvatarCallback, selectedImage, itemClass, classroomPicture, classroomAsset } = this.props;

    return (
      <AvatarMosaic
        images={images}
        itemClass={itemClass}
        selectedImage={selectedImage}
        classroomAsset={classroomAsset}
        classroomPicture={classroomPicture}
        selectAvatarCallback={selectAvatarCallback}
        closeModal={this.closeModal}
        selectImageToCrop={this.setImageToCrop}
      />
    );
  };

  renderCropImage = () => {
    const { existsImage, file } = this.state;
    const { colors, ratio, width, height, originX, originY } = this.props;

    return (
      <CropAvatar
        ratio={ratio}
        width={width}
        height={height}
        originX={originX}
        originY={originY}
        file={file}
        existsImage={existsImage}
        colors={colors}
        setCropperRef={this.setCropperRef}
      />
    );
  };

  renderFooter(showImagesMosaic) {
    return (
      <PanelsBottomRowButton
        hideRow={false}
        disableButtons={false}
        primaryButtonText={showImagesMosaic ? 'common.done' : 'common.cropImage'}
        showCancelButton={true}
        handlePrimaryButtonClick={showImagesMosaic ? this.closeModal : this.handleCropClick}
        handleSecondaryButtonClick={showImagesMosaic ? this.closeModal : this.closeModal}
      />
    );
  }

  render() {
    const { showImagesMosaic } = this.state;

    return (
      <Reveal
        id={AVATAR_SELECTOR_REVEAL}
        footer={this.renderFooter(showImagesMosaic)}
        className="image-reveal-container"
      >
        <HeaderReveal
          title={I18n.t(this.props.selectingClassroomImage ? 'home.classroomImage' : 'userProfile.avatars.title')}
          onCloseOnClick={this.closeModal}
        />

        <div className="avatar-selector-wrapper">
          <div className="avatars-list">{showImagesMosaic ? this.getUserImages() : this.renderCropImage()}</div>
        </div>
      </Reveal>
    );
  }
}

function mapStateToProps(state) {
  return {
    colors: state.theme.colors
  };
}

function mapDispatchToProps(dispatch) {
  return {
    revealActions: bindActionCreators(revealActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageSelectorReveal);
